// Affichage partagé des To Do (liste + détail + création) : source unique, évite la divergence de format.

// Libellés du sexe patient ('H'/'F' stockés en base, alignés sur la contrainte SQL todo_pii_sexe_check).
export const SEXE_LABELS = { H: 'Homme', F: 'Femme' };

// Options du sélecteur H/F (formulaire de création).
export const SEXE_OPTIONS = [
  { value: 'H', label: SEXE_LABELS.H },
  { value: 'F', label: SEXE_LABELS.F },
];

// "Nom Prénom" à partir d'une PII patient (champs éventuellement nuls / absents).
export function patientIdentite(pii) {
  return [pii?.nom, pii?.prenom].filter(Boolean).join(' ').trim();
}
